export default defineI18nConfig(() => ({
  fallbackLocale: 'cs',
}));
